<template>
  <div class="card group-column">
    <div class="header-wrapper">
      <slot name="header"></slot>
      <div class="header-row">
        <span>Personnalité</span><span>{{ metricLabel }}</span>
      </div>
    </div>
    <ul>
      <AuthorMappingCard
        v-for="author in boundColumnData"
        :key="author._id"
        :author="author"
        :metric="props.metric"
        :show-group-tags="showGroupTags"
      />
    </ul>
  </div>
</template>

<script setup>
import { computed } from "vue";
import AuthorMappingCard from "@follaw-fr/components/social-media/stakeholders/organisms/AuthorMappingCard.vue";

const props = defineProps({
  columnData: { type: Array, required: true },
  metric: { type: String, required: true },
  showGroupTags: { type: Boolean, default: true },
});

const metricLabel = computed(
  () =>
    ({
      number_of_publications: "Publications",
      number_of_impressions: "Impressions",
      number_of_amendments: "Amendements",
    })[props.metric]
);

// Display only the top 25 per column to avoid UI slow-downs
const boundColumnData = computed(() =>
  props.columnData.filter((_, idx) => idx < 25)
);
</script>

<style scoped lang="scss">
.group-column {
  display: flex;
  flex-direction: column;

  min-width: 280px;
  padding: 0;

  align-items: center;
  justify-content: flex-start;

  .header-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    width: 100%;
    padding: 8px;

    background-color: white;
  }

  .header-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  ul {
    overflow-y: auto;
    overflow-x: clip;

    list-style: none;
    margin: 0;
    height: 100%;
    padding: 0;
  }
}
</style>
